import { useEffect, useState } from "react";
import { useAuth } from "../../auth/AuthContext";
import {
  DEFAULT_GRAPH_ID,
  getNeighborhood,
  listenEdges,
  listenNodes,
} from "./graphStore";

export function useNodes(graphId = DEFAULT_GRAPH_ID) {
  const { user } = useAuth();
  const [nodes, setNodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!user?.uid) {
      setNodes([]);
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    const unsub = listenNodes(graphId, user.uid, (rows) => {
      setNodes(rows);
      setLoading(false);
      setError("");
    }, (err) => {
      setError(err.message || "Failed to load nodes");
      setLoading(false);
    });

    return () => unsub();
  }, [graphId, user?.uid]);

  return { nodes, loading, error };
}

export function useEdges(graphId = DEFAULT_GRAPH_ID) {
  const { user } = useAuth();
  const [edges, setEdges] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!user?.uid) {
      setEdges([]);
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    const unsub = listenEdges(graphId, user.uid, (rows) => {
      setEdges(rows);
      setLoading(false);
      setError("");
    }, (err) => {
      setError(err.message || "Failed to load edges");
      setLoading(false);
    });

    return () => unsub();
  }, [graphId, user?.uid]);

  return { edges, loading, error };
}

export function useNeighborhood(graphId = DEFAULT_GRAPH_ID, rootNodeId, depth = 1, filters = {}) {
  const { user } = useAuth();
  const [data, setData] = useState({ nodes: [], edges: [] });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    if (!user?.uid || !rootNodeId) {
      setData({ nodes: [], edges: [] });
      setLoading(false);
      return undefined;
    }

    setLoading(true);
    getNeighborhood(graphId, user.uid, rootNodeId, depth, filters.edgeTypeFilter)
      .then((next) => {
        if (!active) return;
        setData(next);
        setLoading(false);
      })
      .catch((err) => {
        if (!active) return;
        setError(err.message || "Failed to load neighborhood");
        setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [graphId, user?.uid, rootNodeId, depth, filters.edgeTypeFilter]);

  return { ...data, loading, error };
}
